import { translate } from 'containers/MundialViews/utils/mundialUtils';
import React from 'react';
import { FadeInImage } from '../../../../../../components/FadeInImage';
import './style.scss';

const NationFlag = ({ urlFlag, nationName, score, translations }) => {
  return (
    <div className="nation-flag">
      <div className="nation-flag__image">
        <FadeInImage
          classNames={['nation-flag__image__img']}
          imageSrc={urlFlag}
          imageAlt="mundial flag"
          width={urlFlag ? 27 : 48}
          height={32}
        />
        {score && (
          <span className="nation-flag__image__score">
            {translate('matches_result_hyphen_label', translations)} {score}
          </span>
        )}
      </div>
      <span className="nation-flag__name">{nationName}</span>
    </div>
  );
};

export default NationFlag;
